import React from 'react';

import { DelinquentClaimsStatistic } from './components';
import { useDelinquentClaimsStatisticLogic, useGetDelinquentClaimsReportURL } from './hooks';
import { useGetDelinquentClaimsStatisticQuery } from './queries';

interface Props {
  isLoading?: boolean;
}
const DelinquentClaimsStatisticContainer: React.FC<Props> = ({ isLoading: isLoadingStat }) => {
  const { isLoading, data } = useGetDelinquentClaimsStatisticQuery();
  const { tiles, isDetailsLinkVisible, isHidden } = useDelinquentClaimsStatisticLogic({ data, isLoading });
  const currentURL = useGetDelinquentClaimsReportURL();

  if (isHidden) {
    return null;
  }

  return (
    <DelinquentClaimsStatistic
      isLoading={isLoading || isLoadingStat}
      url={currentURL}
      tiles={tiles}
      isDetailsLinkVisible={isDetailsLinkVisible}
    />
  );
};

export default DelinquentClaimsStatisticContainer;
